import React, { forwardRef, ReactNode, MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import { useClassnames } from 'hook/use-classnames';
import Loader from 'component/loader';

import { IProps } from './types';
import style from './style.pcss';

// tslint:disable-next-line no-any
const Button = forwardRef<any, IProps>(({disabled = false, isLoading = false, type = 'button', ...props}, ref) => {
    const cn = useClassnames(style, props.className, true);

    const elChildren = (): ReactNode => {
        if(isLoading) {
            return (
                <div className={cn('button__loader')}>
                    <Loader
                        className={cn('button__loader-icon')}
                        theme={props.themeLoader}
                    />
                    {props.children}
                </div>
            );
        }

        return props.children;
    };

    const onClick = (e: MouseEvent): void => {
        if(props.onClick) {
            props.onClick(e);
        }
    };

    const params = {
        className: cn('button', {
            'button_secondary': props.isSecondary,
            'button_small'    : props.isSmall,
            'button_success'  : props.isSuccess,
            'button_error'    : props.isError,
            'button_simple'  : props.isSimple,
            'button_normal-text': props.isNormalText
        }),
        children: elChildren(),
        tabIndex: props.tabIndex,
        title: props.title,
        ref
    };

    if(props.href) {
        if(props.download) {
            return <a download={props.download} onClick={onClick} href={props.href} {...params} />;
        }

        return <a href={props.href} target={props.target} {...params} />;
    } else if(props.to) {
        return <Link to={props.to} target={props.target} {...params} />;
    }

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            {...params}
        />
    );
});

export default Button;
